import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TagModel } from '@shared/models/tag.model';
import { Config } from '@core/config';
import { Cacheable } from 'ts-cacheable';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  constructor(private httpClient: HttpClient) {}

  @Cacheable({ maxAge: 100000 })
  getAllTags(): Observable<{ tags: TagModel[] }> {
    return this.httpClient.get<{ tags: TagModel[] }>(`${Config.serverUrl}tag`, {
      responseType: 'json',
    });
  }

  getAllTagsPromise(): Promise<{ tags: TagModel[] }> {
    return this.httpClient
      .get<{ tags: TagModel[] }>(`${Config.serverUrl}tag`, {
        responseType: 'json',
      })
      .toPromise();
  }
}
